import useTeamSurvivorStandings from '../../../hooks/useTeamSurvivorStandings';
import TeamSurvivorStandingsPage from '../../../components/TeamSurvivorStandingsPage/TeamSurvivorStandingsPage';
import GamecenterNonScheduledLayout from '../../../../common/components/GamecenterNonScheduledLayout/GamecenterNonScheduledLayout';

function TeamSurvivorEntriesPageNonScheduled() {
  const { entries, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, error } =
    useTeamSurvivorStandings({ isShowCurrentUserEntries: true });

  return (
    <GamecenterNonScheduledLayout>
      <TeamSurvivorStandingsPage
        entries={entries}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        isLoading={isLoading}
        error={error}
        page="entries"
      />
    </GamecenterNonScheduledLayout>
  );
}

export default TeamSurvivorEntriesPageNonScheduled;
